import { IDataConnection } from '../../../datasource/dataConnection/serverApi/types/IDataConnection';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../../../siteManagement/serverApi/types/ISiteNameWithId';
import { INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { FlowOutputStep } from '../types/FlowOutputStep';
import { FlowOutputStepRun } from '../types/FlowOutputStepRun';
import { FlowRun } from '../types/FlowRun';
import { RunFlowTask } from '../types/RunFlowTask';

export type GetRunFlowTasksParams = IGetItemsParams;

export type GetRunFlowTasksResult = IGetItemsResult & {
  readonly tasks: ReadonlyArray<RunFlowTask>;
  readonly flows: ReadonlyArray<INamedItem>;
  readonly schedules: ReadonlyArray<ISchedule>;
  readonly sites: ReadonlyArray<ISiteNameWithId>;
  readonly flowOutputSteps: ReadonlyArray<FlowOutputStep>;
  readonly flowRuns: ReadonlyArray<FlowRun>;
  readonly flowOutputStepRuns: ReadonlyArray<FlowOutputStepRun>;
  readonly dataConnections: ReadonlyArray<IDataConnection>;
};

export class GetRunFlowTasksRequest extends Request<GetRunFlowTasksParams, GetRunFlowTasksResult> {
  constructor(params: GetRunFlowTasksParams) {
    super('getRunFlowTasks', params);
  }
}
